import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import useMediaQuery from "../../../shared/utils/useMediaQuery"
import "./article-horoscope.scss"

const ArticleHoroscope = props => {
  const { islog } = props
  const resultQuery = useStaticQuery(graphql`
    query GET_HOROSCOPE_CONTENT {
      allContentfulNolHomeTercerNivel(filter: { titulo: { eq: "Horóscopo" } }) {
        nodes {
          node_locale
          titulo
          slug
          metaImagen {
            description
            file {
              url
            }
          }
          updatedAt
          signosDeLosHoroscopos {
            titulo
            metaImagen {
              description
              file {
                url
              }
            }
            updatedAt
            slug
          }
        }
      }
    }
  `)

  const filteredResult = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )

  const infoHoroscope = filteredResult[0]
  const infoHoroscopeSing = filteredResult[0].signosDeLosHoroscopos
  const [horoscopeActive, sethoroscopeActive] = useState(infoHoroscope)

  const isMobile = useMediaQuery()

  useEffect(() => {
    if (localStorage.getItem("USER_INFO") !== null) {
      sethoroscopeActive(infoHoroscopeSing[getZodiacSignByLog()])
    }
  }, [])

  const getZodiacSignByLog = () => {
    // var birthDate = new Date(JSON.parse(localStorage.getItem('USER_INFO')).birthdate);
    // var m = birthDate.getMonth();
    // var d = birthDate.getDate();
    var birthDate = JSON.parse(
      localStorage.getItem("USER_INFO")
    ).birthdate.split(" ")[0]
    var m = parseInt(birthDate.split("-")[1], 10)
    var d = parseInt(birthDate.split("-")[2], 10)

    return getZodiacSign(d, m)
  }

  const getZodiacSign = (day, month) => {
    var zodiacSigns = {
      capricorn: 9,
      aquarius: 10,
      pisces: 11,
      aries: 0,
      taurus: 1,
      gemini: 2,
      cancer: 3,
      leo: 4,
      virgo: 5,
      libra: 6,
      scorpio: 7,
      sagittarius: 8,
    }

    if ((month === 1 && day <= 20) || (month === 12 && day >= 22)) {
      return zodiacSigns.capricorn
    } else if ((month === 1 && day >= 21) || (month === 2 && day <= 18)) {
      return zodiacSigns.aquarius
    } else if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) {
      return zodiacSigns.pisces
    } else if ((month === 3 && day >= 21) || (month === 4 && day <= 20)) {
      return zodiacSigns.aries
    } else if ((month === 4 && day >= 21) || (month === 5 && day <= 20)) {
      return zodiacSigns.taurus
    } else if ((month === 5 && day >= 21) || (month === 6 && day <= 21)) {
      return zodiacSigns.gemini
    } else if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) {
      return zodiacSigns.cancer
    } else if ((month === 7 && day >= 23) || (month === 8 && day <= 23)) {
      return zodiacSigns.leo
    } else if ((month === 8 && day >= 24) || (month === 9 && day <= 23)) {
      return zodiacSigns.virgo
    } else if ((month === 9 && day >= 24) || (month === 10 && day <= 23)) {
      return zodiacSigns.libra
    } else if ((month === 10 && day >= 24) || (month === 11 && day <= 22)) {
      return zodiacSigns.scorpio
    } else if ((month === 11 && day >= 23) || (month === 12 && day <= 21)) {
      return zodiacSigns.sagittarius
    }
  }


  const userInfoEncrypt= encryptUserInfo()
  const HoroscopeMagazinDatalayer = () => {
    pushDataLayerEvent({
      event: "Interacciones - Articulos",
      category: "magazin",
      sub_category: "horoscopo",
      action: "click",
      label: horoscopeActive.titulo,
      article_name: horoscopeActive.titulo,
      location: window.location.href,
      article_type: "horoscopo",
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  const categoryRedirection = !islog ? "/magazin/" : "/magazin/horoscopo/"
  
  return (
    <>
      <div className="f-carousel-the-new-item">
        <a
          href={removeDoubleSlash(categoryRedirection + horoscopeActive.slug)}
          onClick={() => {
            HoroscopeMagazinDatalayer()
          }}
        >
          {isMobile ? (
            <img
              className="f-carousel-the-new-imagen"
              loading="lazy"
              alt={horoscopeActive.metaImagen.description}
              src={horoscopeActive.metaImagen.file.url}
            />
          ) : (
            <img
              className="f-carousel-the-new-imagen"
              alt={horoscopeActive.metaImagen.description}
              src={horoscopeActive.metaImagen.file.url}
            />
          )}
        </a>
        <div>
          <span className="f-carousel-the-new-category">
            {horoscopeActive.titulo}
          </span>
          <a
            className="f-carousel-the-new-link"
            href={removeDoubleSlash(categoryRedirection + horoscopeActive.slug)}
            onClick={() => {
              HoroscopeMagazinDatalayer()
            }}
          >
            <h3>¡Tu horóscopo de la semana!</h3>
          </a>
        </div>
      </div>
    </>
  )
}

export default ArticleHoroscope

